import React, { useState, useEffect } from 'react';
import Card from "../../../core/Card";
import style from "../../../views/style.module.css";
import Input from "../../../core/Inputs/DefaultInput";
import { useTranslation } from "react-i18next";

const RenameGroupModal = ({
    open,
    onSuccess,
    onCancel,
    groupData = null, // Object with id and name
    currentName = '' // Current group name (fallback if groupData is not provided)
}) => {
    const [groupName, setGroupName] = useState('');
    const [nameError, setNameError] = useState(false);
    const { t } = useTranslation();

    // Initialize form when modal opens or groupData changes
    useEffect(() => {
        if (open) {
            const initialName = groupData?.name || currentName || '';
            setGroupName(initialName);
            setNameError(false);
        }
    }, [open, groupData, currentName]);

    const handleSave = () => {
        const trimmedName = groupName.trim();
        if (!trimmedName) {
            setNameError(true);
            return;
        }

        if (typeof onSuccess === 'function') {
            onSuccess({
                id: groupData?.id,
                name: trimmedName
            });
        }
    };

    const handleCancel = () => {
        setGroupName('');
        setNameError(false);
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSave();
        }
    };

    return (
        <>
            <div
                className={`customvar-modal modal custom-modal fade deleteModal ${open ? 'show' : ''}`}
                style={{ display: `${open ? 'block' : 'none'}` }}
                id="renameGroupModal"
                tabIndex={-1}
                aria-labelledby="renameGroupModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={"formcontainer " + style.container}>
                                <div className={"formvawrapper delete-modal-wrap modal-sm " + style.wrapper}>
                                    <Card view="raised" className={"formstyle p-0 " + style.card}>
                                        <div className="delete-body-wrap delete-language input-margin-bottom">
                                            <div className="heading">
                                                <h3>{t("survey.groups.renameGroup")}</h3>
                                            </div>

                                            <div className="mb-3 mb-md-4 position-relative">
                                                <label className="form-label-custom">{t("survey.groups.groupName")}</label>
                                                <Input
                                                    type='text'
                                                    view='outlined'
                                                    dense={false}
                                                    color='default'
                                                    label=''
                                                    placeholder={t("survey.groups.enterGroupName")}
                                                    clearButton={true}
                                                    success={false}
                                                    error={nameError}
                                                    fill={true}
                                                    errorHelperText={nameError ? t("survey.groups.errors.nameRequired") : null}
                                                    className={"formsinput"}
                                                    value={groupName}
                                                    onChange={(e) => {
                                                        setGroupName(e.target.value);
                                                        if (nameError && e.target.value.trim()) {
                                                            setNameError(false);
                                                        }
                                                    }}
                                                    onKeyPress={handleKeyPress}
                                                />
                                            </div>

                                            {/* Action Buttons */}
                                            <div className="button-wrap d-flex justify-content-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={handleSave}
                                                >
                                                    {t("survey.groups.rename")}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-bordered ms-3"
                                                    onClick={handleCancel}
                                                >
                                                   {t('survey.customVariable.cancel')}
                                                </button>
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className={`modal-backdrop fade ${open ? 'show' : ''}`}
                style={{ display: `${open ? 'block' : 'none'}` }}
                onClick={handleCancel}
            ></div>
        </>
    );
};

export default RenameGroupModal;

